import React from 'react'
import { Accordion, AccordionSummary, AccordionDetails, Typography, Grid, Paper, InputBase } from '@material-ui/core'
import { useSelector } from 'react-redux'

import ExpandMoreIcon from '@material-ui/icons/ExpandMore'

import Header from '../../../../layout/Header'
import Subheader from '../../../../layout/Subheader'
import Loading from '../../../../components/Loading'

import { formatDateTimeToRender } from '../../../../utils/functions'

import useStyles from './style'

function Render ({
  inputs,
  getAncoras,
  getLoading
}) {
  const classes = useStyles()
  const { lastAnchorStore } = useSelector(state => state.anchors)

  return (
    <div className={classes.root}>
      <Header />
      <Subheader title={`Visualizando código da Loja: ${lastAnchorStore} da rede: `} back={false} subanchor={true}/>
      <div className={classes.content}>
        <div className={classes.rootForm}>
          {getLoading
            ? (<Loading />)
            : (
              <>
          <Accordion defaultExpanded>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
              className={classes.summary}
            >
              <Typography className={classes.heading}>Informações</Typography>
            </AccordionSummary>
            <AccordionDetails className={classes.details}>
              <Grid container>
                <Grid item xs={12}>

                  <label className={classes.label}>Código Interno</label>
                  <Paper className={classes.large} elevation={0}>
                    <InputBase
                      style={{ textTransform: 'uppercase !important' }}
                      min
                      className={classes.input}
                      classes={{ input: classes.inputText }}
                      placeholder="Nome"
                      value={inputs.codigoInterno}
                      required
                      name="codigoInterno"
                      readOnly
                      onBlur
                      inputProps={{
                        minLength: 3,
                        maxLength: 100,
                        pattern: '[A-Za-z0-9 ]*',
                        title: 'Não utilize acentos nem caracteres especiais'
                      }}
                    />
                  </Paper>
                </Grid>
                <Grid item xs={6}>
                  <label className={classes.label}>Status</label>
                  <Paper className={classes.medium} elevation={0}>
                  <select
                      className={classes.input}
                      required
                      value={inputs.status}
                      name="status"
                      disabled
                    >
                      <option value="Ativo">Ativo</option>
                      <option value="Inativo">Inativo</option>
                    </select>
                  </Paper>
                </Grid>
                <Grid item xs={6} className={classes.item}>
                <label className={classes.label}>Rede Loja</label>
                  <Paper className={classes.medium} elevation={0}>
                  <select
                      className={classes.input}
                      required
                      value={inputs.ancoraLojaId}
                      name="ancoraLojaId"
                      disabled
                      readOnly
                    >
                      <option value="">FALTA PREENCHER</option>
                      {getAncoras.map(ancora => (
                        <option key={ancora.ancoraLojaId} value={ancora.ancoraLojaId}>{ancora.nome}</option>
                      ))}
                    </select>
                  </Paper>
                </Grid>
              </Grid>
            </AccordionDetails>
          </Accordion>

<Accordion defaultExpanded>
<AccordionSummary
  expandIcon={<ExpandMoreIcon />}
  aria-controls="panel1a-content"
  id="panel1a-header"
  className={classes.summary}
>
  <Typography className={classes.heading}>Dados do Registro</Typography>
</AccordionSummary>
<AccordionDetails className={classes.details}>
  <Grid container>

  <Grid item xs={6}>
                  <label className={classes.label}>Data de Registro</label>
                  <Paper className={classes.medium} elevation={0}>
                    <InputBase
                      className={classes.input}
                      value={inputs.dataRegistro && formatDateTimeToRender(inputs.dataRegistro)}
                      readOnly
                      placeholder="Data do Registro"
                    />
                  </Paper>
                </Grid>

                <Grid item xs={6}>
                  <label className={classes.label}>Data da Atualização</label>
                  <Paper className={classes.medium} elevation={0}>
                    <InputBase
                      className={classes.input}
                      value={inputs.dataAtualizacao ? formatDateTimeToRender(inputs.dataAtualizacao) : ''}
                      readOnly
                      placeholder="Data da Atualização"
                    />
                  </Paper>
                </Grid>

  </Grid>
</AccordionDetails>
</Accordion>
</>
              )}
        </div>

      </div>
    </div>
  )
}

export default Render
